import React from 'react'
import PropTypes from 'prop-types'

const BOTShopForTiresHeader = ({ placeholders: { content = []} = {}, ...props }) =>
  <React.Fragment>
    { content }
  </React.Fragment>

BOTShopForTiresHeader.propTypes = {
  '@type': PropTypes.string,
  name: PropTypes.string,
  placeholders: PropTypes.shape({
    content: PropTypes.array
  })
}

BOTShopForTiresHeader.type = 'BOTShopForTiresHeader'
BOTShopForTiresHeader.placeholders = ['content']

export default BOTShopForTiresHeader
